import React, { useEffect } from 'react'
import { MdDelete } from 'react-icons/md'
import { auth, firestore, signInWithGoogle } from '../../firebase/firebase-utils';
import Spinner from '../../Text-Editor/Spinner';

const Delete = ({ docid, collection, reload }) => {
    const [User, setUser] = React.useState(null);
    const [Delete, setDelete] = React.useState(false)
    const [loader, setLoader] = React.useState(false)

    auth.onAuthStateChanged(async user => {
        if (user) {
            await setUser(user)
        }
    })

    useEffect(() => {
        if (User) {
            firestore.collection(collection).doc(docid).onSnapshot((doc) => {
                if (doc.exists) {
                    if (doc.data().uid === User.uid) {
                        setDelete(true)
                    } else { setDelete(false) }
                }
            })
        }
    }, [docid, collection, User,loader])

    const DeletePost = () => {
        setLoader(true)
        if (User) {
            firestore.collection(collection).doc(docid).delete().then(() => {
                window.alert('Deleted successfully')
                if (reload) {
                    window.location.reload()
                }
            }).catch((error) => {
                window.alert(error)
            })
        } else {
            window.alert("Sign In required");
            signInWithGoogle();
        }
        setLoader(false)
    }

    return (
        <>
            {loader ? <Spinner /> : null}
            {Delete ? <MdDelete style={{ fontSize: '25px' }} onClick={DeletePost} /> : null}
        </>
    )
}

export const DeleteComment = ({ docid, collection, query }) => {
    const [User, setUser] = React.useState(null);
    const [Delete, setDelete] = React.useState(false);
    const [comments, setComments] = React.useState([]);

    auth.onAuthStateChanged(async user => {
        if (user) {
            await setUser(user)
        }
    })

    useEffect(() => {
        if (User) {
            firestore.collection(collection).doc(docid).onSnapshot((doc) => {
                if (doc.exists) {
                    setComments(doc.data().comments)
                    var count = doc.data().comments.reduce((acc, ele) => {
                        return ele.query === query ? acc + 1 : acc
                    }, 0)
                    if (count !== 0) {
                        setDelete(true)
                    } else { setDelete(false) }
                }
            })
        }
    }, [docid, collection, User, query])

    const DeleteCom = () => {
        if (User) {
            var deletedComments = comments.filter(comment => comment.query !== query)
            deletedComments = deletedComments.filter(comment => comment.query !== undefined)
            firestore.collection(collection).doc(docid).update({
                comments: deletedComments
            }).then(() => {
                window.alert("comment deleted successfully")
            })
        } else {
            window.alert("Sign In required");
            signInWithGoogle();
        }
    }

    return (
        Delete ? <MdDelete style={{ fontSize: '25px' }} onClick={DeleteCom} /> : null

    )
}

export default Delete
